import React, { useEffect } from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import { redirectIfNeeded } from "../utils/helpers"
import SliceZone from "../components/slice-zone"
import { withPreview } from "gatsby-source-prismic"

const B2BV2Template = ({ data, pageContext, location }) => {
  const page = data?.prismicB2BHomepageV2.data
  if (!page) return null

  const { lang: locale } = pageContext
  useEffect(() => {
    redirectIfNeeded({ locale, location })
  }, [])

  // because of images take time to load we scroll to the element manually with a little delay https://miguelpiedrafita.com/snippets/scrollToHash
  useEffect(() => {
    const { hash } = location

    if (!hash) {
      return
    }
    setTimeout(() => {
      const anchor = document.querySelector(hash)
      const offset = anchor.getBoundingClientRect().top + window.scrollY

      window.scroll({ top: offset, left: 0 })
    }, 800)
  }, [])

  return (
    <Layout
      metadata={{
        title: page.meta_title,
        description: page.meta_description,
        keywords: page.meta_keywords,
        image: page.meta_image && page.meta_image.url,
      }}
      mainPage="companies"
      locale={locale}
      path={location && location.pathname}
    >
      {page.body && (
        <SliceZone
          allSlices={page.body}
          locale={locale}
          path={location && location.pathname}
        />
      )}
    </Layout>
  )
}

export const query = graphql`
  query b2bV2Query($uid: String, $lang: String) {
    prismicB2BHomepageV2(uid: { eq: $uid }, lang: { eq: $lang }) {
      alternate_languages {
        id
        lang
        type
        uid
      }
      data {
        meta_image {
          url
        }
        meta_title
        meta_keywords
        meta_description
        body {
          ... on PrismicB2bHomepageV2BodyHeroSection {
            id
            slice_type
            primary {
              link_text
              subtitle
              theme
              title
              button_text
              link {
                url
                type
                target
              }
              background_image {
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 700) {
                      ...GatsbyImageSharpFluid_noBase64
                    }
                  }
                }
              }
            }
          }
          ... on PrismicB2bHomepageV2BodyPartnersCarousel {
            id
            slice_type
            primary {
              title_is_bold
              title
            }
            items {
              image {
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 700) {
                      ...GatsbyImageSharpFluid_noBase64
                    }
                  }
                }
              }
            }
          }
          ... on PrismicB2bHomepageV2BodyTestimonialCarousel {
            id
            slice_type
            primary {
              title
            }
            items {
              name
              role
              text
              image {
                localFile {
                  childImageSharp {
                    fixed(width: 80) {
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
          }
          ... on PrismicB2bHomepageV2BodyInfoWithIcons {
            id
            slice_type
            primary {
              subtitle
              title
            }
            items {
              body1
              link_text
              title
              link_url {
                url
                type
                target
              }
              button_icon {
                url
              }
            }
          }
          ... on PrismicB2bHomepageV2BodyHomepageIntegrations {
            id
            slice_type
            primary {
              title
              subtitle
              button_text
              button_link {
                url
                type
                target
              }
            }
            items {
              logo {
                url
              }
            }
          }
          ... on PrismicB2bHomepageV2BodyPricingCards {
            id
            slice_type
            slice_label
            primary {
              title
              button_text
              button_url {
                url
                type
                target
              }
            }
            items {
              plan_name
              plan_subtitle
              price_line {
                html
                raw
                text
              }
              plan_body {
                html
                raw
                text
              }
            }
          }
          ... on PrismicB2bHomepageV2BodyNetwork {
            id
            slice_type
            primary {
              sector1
              sector2
              sector3
              title
              image {
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 700) {
                      ...GatsbyImageSharpFluid_noBase64
                    }
                  }
                }
              }
            }
          }
          ... on PrismicB2bHomepageV2BodyFaqVideo {
            id
            slice_type
            slice_label
            primary {
              button_text
              title
              subtitle
              button_url {
                url
                type
                target
              }
            }
            items {
              tab_title
              video_number
            }
          }
          ... on PrismicB2bHomepageV2BodyFeatures {
            id
            slice_type
            primary {
              title
              button_text
              button_link {
                url
                type
                target
              }
              body1 {
                html
                raw
                text
              }
              image {
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 700) {
                      ...GatsbyImageSharpFluid_noBase64
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export default withPreview(B2BV2Template)
